import { createContext, useState, useEffect } from "react";

// 1. أنشأنا "السياق" أو السحابة التي ستحمل البيانات
export const TaskContext = createContext();

// 2. أنشأنا "المزود" (Provider)
// {children} هنا تعني: "أي مكون سأضعه داخل TodosProvider في ملف App.js"
export const TaskProvider = ({ children }) => {
  
  // نقلنا الـ State من ملف Tasks إلى هنا ليكون "عاماً" لكل التطبيق
 const [allTasks, setAllTasks] = useState(() => {
    const storage = localStorage.getItem("tasks");
    return storage ? JSON.parse(storage) : []; // ابدأ ببيانات فارغة إذا لم يوجد تخزين
  });

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(allTasks));
  }, [allTasks]);
  // دالة الإضافة: نقلناها من ملف Tasks إلى هنا
  const addTask = (title, details) => {
    if (!title.trim()) return;
    const newTask = { id: Date.now(), title, details, isCompleted: false };
    const updatedTasks = [...allTasks, newTask]
    // localStorage.setItem("tasks",JSON.stringify(updatedTasks))
    setAllTasks(updatedTasks);

  };

  // دالة الإكمال: نقلناها من ملف Tasks إلى هنا
  const toggleTask = (taskId) => {
    const updated = allTasks.map((t) => {
      if (t.id === taskId) return { ...t, isCompleted: !t.isCompleted };
      return t;
    });
        // localStorage.setItem("tasks",JSON.stringify(updated))

    setAllTasks(updated);
  };
  const deletTask = (taskId) => {
    const updated = allTasks.filter((t) => {
      return t.id !== taskId
    });
    // localStorage.setItem("tasks",JSON.stringify(updated))
    
    setAllTasks(updated);
  };
  // داله التعديل
 
   const editTask = (taskId, newTitle, newDetails) => {
    if (!newTitle.trim()) return;
    const updated = allTasks.map((t) => {
      if (t.id === taskId) {
        // نحدث العنوان والتفاصيل ونبقي باقي البيانات (مثل isCompleted) كما هي
        return { ...t, title: newTitle, details: newDetails };
      }
      return t;
    });

    setAllTasks(updated);
  };
 const completed = allTasks.filter( (t) => {
  return t.isCompleted
 })
 const notCompleted = allTasks.filter( (t) => {
  return !t.isCompleted
 })

  return (
    // الـ value هي "الكهرباء" التي سنوزعها على المكونات (بيانات ودوال)
    <TaskContext.Provider value={{ allTasks, addTask, toggleTask, deletTask, editTask, setAllTasks, completed, notCompleted }}>
      {children} 
      {/* كلمة children هنا ضرورية لكي تظهر المكونات (مثل Tasks) داخل السحابة */}
    </TaskContext.Provider>
  );
};